
import $api from '../../services/axios';

export const SET_CONSULTANCIES = 'SET_CONSULTANCIES';
export const SET_CONSULTANCY = 'SET_CONSULTANCY';
export const SEARCH = 'SEARCH';

const state = {
    consultancies: [],
    consultancy: {},
    search: ''
};

const mutations = {
    [SET_CONSULTANCIES](state, payload) {
        state.consultancies = payload
    },
    [SET_CONSULTANCY](state, payload) {
        state.consultancy = payload
    },
    [SEARCH](state, payload){
        state.search = payload
    }
};

const actions = {
    async getConsultancies(context) {
        let url = `students/clients`;
        let res = await $api.get(url);
        await context.commit('SET_CONSULTANCIES', res.data.clients);
        return res.data;
    },
    async getConsultancy(context, consultancyId){
        let url = `students/client/${consultancyId}`;
        let res = await $api.get(url);
        await context.commit('SET_CONSULTANCY',res.data.client);
        return res.data;
    }


};

/*
|--------------------------------------------------------------------------
| Getters
|--------------------------------------------------------------------------
*/
const getters = {
    consultancies: state => state.consultancies,
    consultancy: state => state.consultancy,
    search: state => state.search,
};

/*
|--------------------------------------------------------------------------
| Export the module
|--------------------------------------------------------------------------
*/
export default {
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/consultancy.js